import { CONFIGS } from "CONFIGS";
import { mockOrFetch } from "../../../../utils";
// eslint-disable-next-line jest/no-mocks-import
import mockData from "../../../../../__mocks__/packages-hotels.json";

const getHotels = (lang, gateway, destination, brand = "SWG") => {
	const packageHotelsAPI = CONFIGS.PACKAGES.HOTELS;

	if (!gateway) {
		return new Promise((resolve, reject) => {
			reject(new Error("No gateway provided"));
		});
	}

	if (!destination) {
		return new Promise((resolve, reject) => {
			reject(new Error("No destination provided"));
		});
	}

	return mockOrFetch({
		apiUrl: packageHotelsAPI,
		fetchOpts: {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				brand,
				lang,
				gateway,
				destinationId: destination,
				chainsOnly: false
			})
		},
		mockData
	});
};

export default getHotels;
